export enum CashPointsRatio {
  FullCash = 'full_cash',
  FullPoints = 'full_points',
  CashAndPoints = 'cash_and_points',
}
